import { useState } from 'react';

import { IconButton, Tooltip } from '@mui/material';

import SendIcon from 'domains/core/components/SvgIcons/SendIcon';

import SmsSendTestDialog from './SmsSendTestDialog';

type Props = {
    content: string;
};

const SmsSendTestIconButton = ({ content }: Props) => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const isButtonDisabled = content.length < 3 || content.length > 1600;

    return (
        <>
            <SmsSendTestDialog isOpen={isDialogOpen} message={content} setIsOpen={setIsDialogOpen} />
            <Tooltip
                placement="top"
                title={
                    isButtonDisabled
                        ? 'Please provide a content between 3 and 1600 characters before sending a test text message.'
                        : 'Send Test Text Message'
                }
            >
                <span>
                    <IconButton
                        aria-label="Send Test Text Message"
                        data-testid="send-test-icon-button"
                        disabled={isButtonDisabled}
                        size="large"
                        onClick={() => setIsDialogOpen(true)}
                    >
                        <SendIcon />
                    </IconButton>
                </span>
            </Tooltip>
        </>
    );
};

export default SmsSendTestIconButton;
